import { Link } from "react-router-dom";
import type { ContentItem } from "@/mocks/content";
import { formatDate } from "@/utils/format";

export default function VideoCard({ item }: { item: ContentItem }) {
  return (
    <Link
      to={`/detail/${item.type}/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-100">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} - 百度一下`}
          className="h-full w-full object-cover object-top"
        />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950/45 text-background-50 transition-transform group-hover:scale-110">
            <i className="ri-play-fill text-xl" />
          </span>
        </span>
        {item.duration && (
          <span className="absolute bottom-2 right-2 rounded bg-foreground-950/70 px-1.5 py-0.5 text-xs text-background-50">
            {item.duration}
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {item.title}
        </h3>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line" />
            {item.author}
          </span>
          {item.views && <span className="whitespace-nowrap">{item.views}</span>}
          <span className="whitespace-nowrap">{formatDate(item.date)}</span>
        </div>
      </div>
    </Link>
  );
}